import { breakpoints } from '@theme/constants';
import { getAttributeValue } from '@theme/dom';
import { HTMLCustomElement } from '@theme/html-custom-element';

class StoreHeroImages extends HTMLCustomElement {
  animation = {
    duration: getAttributeValue(this, 'speed', 36000),
    easing: (transition) => transition,
  };

  async connectedCallback() {
    if (super.connectedCallback) super.connectedCallback();

    // eslint-disable-next-line import/no-unresolved
    const { default: KeenSlider } = await import('keen-slider');

    this.slider = new KeenSlider(this, this.getOptions());
  }

  /**
   * Returns the slider options.
   * @returns {object}
   */
  getOptions() {
    return {
      loop: true,
      renderMode: 'performance',
      drag: true,
      mode: 'free',
      selector: Array.from(this.children),
      slides: {
        perView: this.children.length === 1 ? 1 : 1.4,
      },
      breakpoints: {
        [`(min-width: ${breakpoints.large}px)`]: {
          slides: {
            perView: getAttributeValue(this, 'is-narrow', false) ? 1.3 : 2.4,
          },
        },
      },

      /**
       * Slider was created.
       * @param {object} slider
       */
      created: ((slider) => {
        this.paused = !getAttributeValue(this, 'autoplay', true);

        !this.paused && this.startAutoSlide(slider);
      }).bind(this),

      /**
       * The update function was called due to a size change or other trigger.
       * @param {object} slider
       */
      updated: ((slider) => {
        !this.paused && slider.moveToIdx(slider.track.details.abs + 5, true, this.animation);
      }).bind(this),

      /**
       * Animation has ended.
       * @param {object} slider
       */
      animationEnded: ((slider) => {
        !this.paused && slider.moveToIdx(slider.track.details.abs + 5, true, this.animation);
      }).bind(this),
    };
  }

  /**
   * Starts the autoplay sliding.
   * @param {object} slider
   */
  startAutoSlide(slider) {
    slider.moveToIdx(5, true, this.animation);
  }
}

if (!customElements.get('store-hero-images')) customElements.define('store-hero-images', StoreHeroImages);
